import script from "./StudentJenphoneChat.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentJenphoneChat.vue?vue&type=script&setup=true&lang=js"

import "./StudentJenphoneChat.vue?vue&type=style&index=0&id=7d1d5d05&lang=scss&scoped=true"

import exportComponent from "/Users/chronosme/Domains/mathgs2.mu/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d1d5d05"]])

export default __exports__